<template>
    <div>
        <input
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5 mb-3 md:w-1/2 md:w-1/3 ml-auto"
        :placeholder="$t('composants.card_list.rechercher_parmis_la_liste')"
        type="text"
        v-model="research"
        @input="research = $event.target.value"
        />
        <div
        v-for="(item, index) in dataSrcToDisplay"
        :key="item.id"
        @click="onClick(item)"
        :test-id="'list-item-' + index"
        class="relative flex flex-col min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded"
        >
            <div class="flex items-center p-6 no-gutters">
                <div class="mr-2">
                    <img
                    style="height: 40px"
                    v-lazy="imgSource(item)"
                    >
                </div>
                <h5 v-if="!item.hideLabel" class="mb-0">{{ item.label || '-' }}</h5>
            </div>
        </div>
        <div
        class="relative flex flex-col min-w-0 px-5 py-4 mb-3 font-light text-gray-400 break-words bg-white border border-gray-300 rounded border-1 my-rounded"
        v-if="dataSrcToDisplay.length <= 0"
        >
            {{$t('composants.card_list.aucun_resultat')}}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dataSrc: {
            type: Array,
            required: true
        },
        callback: {},
        id: {
            type: String
        }
    },

    watch: {
        research: function() {
            this.parseArray()
        }
    },

    data() {
        return {
            research: "",
            dataSrcToDisplay: this.dataSrc,
            newArray: [],
        }
    },

    methods: {
        parseArray() {
            this.dataSrcToDisplay = this.dataSrc.filter(item => item.label.toUpperCase().includes(this.research.toUpperCase()))
        },

        onClick(item) {
            this.$emit('click', item)
            if (this.callback) {
                this.callback(item, this.id)
            }
        },

        imgSource(item) {
            return item.img ? item.img : 'https://disticloudfiles.net/img/savinfo/default/img-broken.png'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavItemsCardsList.vue